/* eslint-disable global-require */

export const athena = require('./amazon-athena.png').default;
export const redshift = require('./amazon-redshift.png').default;
export const azuresynapseanalytics = require('./azuresynapseanalytics.png').default;
export const ftps = require('./ftps.png').default;
export const googlecloudsql = require('./google-cloud-sql.png').default;
export const google = require('./google.png').default;
export const instagram = require('./instagram.png').default;
export const mongo = require('./mongodb.png').default;
export const oracle = require('./oracle.png').default;
export const postgresql = require('./postgresql.png').default;
export const salesforce = require('./salesforce.png').default;
export const shopify = require('./shopify.png').default;
export const xero = require('./xero.png').default;
export const amazondynamodb = require('./amazon-dynamodb.png').default;
export const s3 = require('./amazon-s3.png').default;
export const bingads = require('./bing-words.png').default;
export const analytics = require('./google-analytics.png').default;
export const ga4 = require('./google-analytics.png').default;
export const gs = require('./google-cloud-storage.png').default;
export const hdfs = require('./hdfs.png').default;
export const intercom = require('./intercom.png').default;
export const mysql = require('./mysql.png').default;
export const rackspace = require('./rackspace.png').default;
export const sap = require('./sap.png').default;
export const snowflake = require('./snowflake.png').default;
export const youtube = require('./youtube.png').default;
export const amazonemr = require('./amazon-emr.png').default;
export const aws = require('./aws.png').default;
export const db2 = require('./db2.png').default;
export const bigquery = require('./google-big-query.png').default;
export const bigqueryv2 = require('./google-big-query.png').default;
export const googlesheets = require('./google-sheets.png').default;
export const googledrive = require('./google-drive.png').default;
export const herokupostgres = require('./heroku-postgres.png').default;
export const linkedin = require('./linkedin.png').default;
export const netsuite = require('./netsuite.png').default;
export const netsuitesoap = require('./netsuite.png').default;
export const pipedrive = require('./pipedrive.png').default;
export const redis = require('./redis.png').default;
export const segment = require('./segment.png').default;
export const softlayer = require('./softlayer.png').default;
export const amazonrds = require('./amazon-rds.png').default;
export const azureblobstorage = require('./azure-blob-storage.png').default;
export const facebookadsinsights = require('./facebook.png').default;
export const facebookads = require('./facebook.png').default;
export const googlecloudspanner = require('./google-cloud-spanner.png').default;
export const adwords = require('./google-words.png').default;
export const heroku = require('./heroku.png').default;
export const sqlserver = require('./microsoft.png').default;
export const openstack = require('./openstack.png').default;
export const postgres = require('./postgresql.png').default;
export const restapi = require('./restapi.png').default;
export const sftp = require('./sftp.png').default;
export const vertica = require('./vertica.png').default;
export const marketingcloud = require('./marketingcloud.png').default;
export const marketingcloudrest = require('./marketingcloud.png').default;
export const salesforcesoap = require('./salesforce.png').default;
export const as400 = require('./as400.png').default;
export const tiktokads = require('./tiktokads.png').default;

export const googlecloudpostgres = googlecloudsql;
export const alloy = require('./alloy.png').default;
